<div class="update-lingerie-modal">
	<h2>Modification de la lingerie n°{{lingerie.id}} :</h2>
	<form [formGroup]="form" class="flex flex-col">
		<mat-form-field>
			<mat-label>Nom de la lingerie</mat-label>
			<input matInput formControlName="nom" placeholder="Renseigner un nom de lingerie" autocomplete="off">
			<mat-error *ngIf="form.hasError('required',['nom'])">Un nom de lingerie est requis</mat-error>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Type de lingerie</mat-label>
			<mat-select formControlName="type" multiple>
				<mat-option *ngFor="let type of types" [value]="type.id">{{type.libelle}}</mat-option>
			</mat-select>
			<mat-error *ngIf="form.hasError('required',['type'])">Au moins un type de lingerie est requis</mat-error>
		</mat-form-field>
		<mat-checkbox formControlName="activated" color="primary">
			Lingerie activée
		</mat-checkbox>
		<div mat-dialog-actions>
			<button mat-raised-button (click)="refuse()" color="white">Annuler</button>
			<button mat-raised-button color="primary" (click)="onSubmit()">Modifier</button>
		</div>
	</form>

</div>